<template>
	<div>
		<!-- Regular Questions Section -->
		<div v-if="regularQuestions.length > 0">
			<div class="section-header">
				<span class="section-title font-weight-medium">Sorular</span>
			</div>
			<v-row v-for="(item, index) in regularQuestions" :key="`question_${index}`">
				<v-col>
					<fieldset class="talentics-fieldset talentics-fieldset-paddings">
						<legend>
							{{ handleGetQuestion({ item }) }}
							<span v-if="isRequired(item)" style="color: red; margin-left: 4px;">*</span>
						</legend>
						<div>
							{{ handleGetAnswer({ item }) }}
						</div>
					</fieldset>
				</v-col>
			</v-row>
		</div>

		<!-- Approval Checkboxes Section -->
		<div v-if="approvalCheckboxes.length > 0" style="margin-top: 1rem;">
			<div class="section-header">
				<span class="section-title">Onay Kutuları</span>
			</div>
			<v-row v-for="(item, index) in approvalCheckboxes" :key="`checkbox_${index}`">
				<v-col>
					<fieldset class="talentics-fieldset talentics-fieldset-paddings">
						<legend>
							{{ handleGetQuestion({ item }) }}
							<span v-if="isRequired(item)" style="color: red; margin-left: 4px;">*</span>
						</legend>
						<div>
							<v-icon 
								:color="item.value === true ? 'success' : 'error'" 
								small
							>
								{{ item.value === true ? 'check_circle' : 'cancel' }}
							</v-icon>
						</div>
					</fieldset>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AdditionalQuestions',
	props: {
		questionSet: {
			type: Array,
			required: false,
			default() {
				return [];
			},
		},
		answerSet: {
			type: Array,
			required: false,
			default() {
				return [];
			},
		},
	},
	computed: {
		regularQuestions() {
			return this.answerSet.filter(item => item.type !== 'approval_checkbox');
		},
		approvalCheckboxes() {
			return this.answerSet.filter(item => item.type === 'approval_checkbox');
		},
	},
	methods: {
		isRequired(item) {
			if (item.required !== undefined) {
				return item.required === true;
			}
			
			const { questionSet } = this;
			const { propName } = item;

			if (propName && questionSet) {
				const question = questionSet.find(
					questionSetItem => questionSetItem.propName === propName,
				);
				
				if (question && question.required !== undefined) {
					return question.required === true;
				}
			}
			
			return false;
		},
		handleGetAnswer({ item }) {
			const { questionSet } = this;
			const { propName } = item;

			if (propName) {
				const question = questionSet.find(
					questionSetItem => questionSetItem.propName === propName,
				);
				
				if (question) {
					if (question.type === 'dropdown' || question.type === 'radio') {
						const { options } = question;
						const option = options.find(
							optionItem => optionItem.value === item.value,
						);

						if (option) {
							return option.label;
						} else {
							return item.value || '-';
						}
					} else {
						return item.value || '-';
					}
				} else {
					return item.value || '-';
				}
			} else {
				return item.value || '-';
			}
		},
		handleGetQuestion({ item }) {
			const { questionSet } = this;
			const { propName } = item;

			if (propName) {
				const question = questionSet.find(
					questionSetItem => questionSetItem.propName === propName,
				);

				if (question) {
					return question.label;
				} else {
					return item.label;
				}
			} else {
				return item.label;
			}
		},
	},
};
</script>

<style scoped>
.section-header {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
	gap: 8px;
}

.section-title {
	font-size: 13px;
	font-weight: 500;
	white-space: nowrap;
}

/* .section-header::after {
	content: '';
	flex: 1;
	height: 5px;
	background-color: #e0e0e0;
} */
</style>